import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { environmentURL } from 'src/environments/environments';

/**
 * Añade Authorization Bearer con token fijo web hacia sdm-ms y sdm-backend
 * cuando falta el header o el Bearer va vacío. No sobrescribe JWT u otro Bearer no vacío.
 */
@Injectable()
export class ApiAuthInterceptor implements HttpInterceptor {
  intercept(
    req: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    const { apiBaseUrl, apiBackendUrl, webAppClientToken } = environmentURL;
    if (!webAppClientToken?.trim()) {
      return next.handle(req);
    }

    const url = req.url;
    const targetsMs = url.startsWith(apiBaseUrl);
    const targetsBackend = url.startsWith(apiBackendUrl);
    if (!targetsMs && !targetsBackend) {
      return next.handle(req);
    }

    const auth = req.headers.get('Authorization');
    if (auth) {
      const trimmed = auth.trim();
      if (/^Bearer\s+/i.test(trimmed)) {
        const tokenPart = trimmed.replace(/^Bearer\s+/i, '').trim();
        if (tokenPart.length > 0) {
          return next.handle(req);
        }
        return next.handle(
          req.clone({
            setHeaders: {
              Authorization: `Bearer ${webAppClientToken}`,
            },
          })
        );
      }
      return next.handle(req);
    }

    return next.handle(
      req.clone({
        setHeaders: {
          Authorization: `Bearer ${webAppClientToken}`,
        },
      })
    );
  }
}
